<template>
    <section style="background: #FFFFFF">
        <div class="titleName">更新日志</div>
        <div class="comments-list" v-loading="listLoading">
            <div class="lifeline"></div>
            <div class="comments-item" v-for="(item,index) in msgboardList">
                <div class="dateview">{{ item.createtime | time}}</div>
                <div class="comment">
                    <div class="name">{{item.title}}</div>
                    <div class="words">
                        <ul>
                            <li style="text-align: left" v-for="(item1,index1) in item.content">{{item1}}</li>
                        </ul>
                    </div>
                    <!-- <div class="words" v-for="(item1,index1) in item.Content">{{item1}}</div> -->
                </div>
            </div>
        </div>
    </section>
</template>
<script>

    //import NProgress from 'nprogress'
    import { Config } from "@/config/config"
    import { mapState } from 'vuex'
    import Notify from '../../api/notifyMsg'

    export default {

        data() {
            return {
                content: '',
                msgboardList: [],
                apiUrl: "/api/v1/console/versioninfo",
                listLoading:false
            }
        },
        filters: {
            time(value) {
                return new Date(parseInt(value)).toLocaleString().replace(/年|月/g, "-").replace(/日/g, " ");
            }
        },
        computed: mapState({
            user: state => state.user
        }),
        created() {
            this.getUpdateInfoData()
        },
        methods: {
            getUpdateInfoData() {
                var _this = this
                var url = Config.url + _this.apiUrl
                var data = {
                    params: {
                        type: "about",
                        token: _this.user.token
                    }
                }
                _this.listLoading = true
                _this.$http.get(url, data)
                    .then((response) => {
                        _this.listLoading = false
                        if (response.data.Error_code === 1000) {
                            if (response.data.messages === null) return
                            console.log("message:", response.data.messages)
                            _this.InitUpdateInfo(response.data.messages)
                        } else {
                            Notify.errMsgNotify(response.data.Error_code, this)
                            return
                        }
                    })
                    .catch(function(response) {
                        _this.listLoading = false
                        Notify.catchMsgNotify(this)
                        console.log(response)
                    })
            },
            InitUpdateInfo(MessagesData) {
                var _this = this

                let msgData = MessagesData
                let msgLen = MessagesData.length
                for (let ii = 0; ii < msgLen; ii++) {
                    msgData[ii].content = msgData[ii].content.split("\n")
                    //console.log("cccccc" + msgData[ii].content)
                }

                this.msgboardList = MessagesData

                // console.log(this.msgboardList)

                return
            },

        }
    }
</script>
<style scoped>
    section.content-wrap {
        position: relative;
    }

    .comments-wrap {
        display: flex;
        margin-left: 50px;
        margin-top: 30px;
    }

    .avatar {
        width: 50px;
        height: 50px;
        margin: 0 20px;
        border-radius: 50%;
        /*background: url('../assets/images/avatar.jpg') no-repeat;*/
        background-size: cover;
    }

    .comments-content {
        position: relative;
    }

    .comments-content textarea {
        border: none;
        border-radius: 10px;
        overflow: hidden;
        resize: none;
        outline: none;
        overflow: auto;
        padding: 10px;
        font-size: 16px;
    }

    .gv {
        text-decoration: none;
        /*background: url('../assets/images/nav_gv.png') repeat 0px 0px;*/
        width: 130px;
        height: 43px;
        display: block;
        text-align: center;
        line-height: 43px;
        cursor: pointer;
        float: left;
        margin: 10px 2px 10px 2px;
        font: 18px/43px 'microsoft yahei';
        color: #066197;
    }

    .gv:hover {
        /*background: url('../assets/images/nav_gv.png') repeat 0px -43px; */
        color: #1d7eb8;
        -webkit-box-shadow: 0 0 6px #1d7eb8;
        transition-duration: 0.5s;
    }

    .comments-button {
        position: absolute;
        right: 5px;
        top: 120px;
    }

    .comments-list {
        position: relative;
        border-top: 1px solid #fff;
        width: 70%;
        margin: 10px 0 50px 40px;
        padding-left: 50px;
    }

    .lifeline {
        position: absolute;
        /* min-height: 300px; */
        height: 100%;
        top: 20px;
        left: 200px;
        width: 2px;
        background: rgba(211, 220, 230, 1);
    }

    .comments-item {
        margin-left: 200px;
        padding-top: 40px;
        position: relative;
    }

    .comments-item::before {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 400%;
        position: absolute;
        background: rgba(255, 255, 255, 1);
        border: 2px solid #20A0FF;
        left: -56px;
        top: 50px;
    }

    .dateview {
        position: absolute;
        left: -215px;
        top: 50px;
        z-index: 1;
        font-size: 14px;
        color: #99a9bf;
    }

    .comment {}

    .comment .name {
        line-height: 30px;
        font-size: 22px;
        color: #324057;
        text-align: left;
    }

    .words {
        line-height: 20px;
        font-size: 14px;
        color: #5e6d82;
    }

    .titleName {
        position: absolute;
        left: 355px;
        color: #324057;
    }
</style>



// WEBPACK FOOTER //
// src/components/about/About.vue